export default __webpack_public_path__ + "static/media/step2.2bcd9989.gif";